import React, { useState } from "react";
import { Layout } from "antd";
import ECOSidebar from "../components/home/ECB/ECBSidebar/ECOSidebar";
import Header from "../layout/Header";
import Footer from "../layout/Footer";
import { Drawer } from "antd";
import { MenuFoldOutlined } from "@ant-design/icons";
export default function ECBSidebarLayout({ children }) {
  const { Sider, Content } = Layout;
  const [open, setOpen] = useState(false);
  const showDrawer = () => {
    setOpen(true);
  };
  const onClose = () => {
    setOpen(false);
  };
  return (
    <div>
      <Layout>
        <header>
          <Header />
        </header>
        <div className="main-showDrawer-btn">
          <button
            onClick={showDrawer}
            className="icon-dawer"
            style={{ marginLeft: "10px" }}
          >
            <MenuFoldOutlined />
          </button>
        </div>
        <Layout>
          <Content>{children}</Content>
        </Layout>
        <footer>
          <Footer />
        </footer>
      </Layout>
      <Drawer onClose={onClose} open={open}>
        <ECOSidebar />
      </Drawer>
    </div>
  );
}
